// extracted by mini-css-extract-plugin
module.exports = {"container":"PaymentSettings_container_3HxOi","header":"PaymentSettings_header_1cR9l","navigation":"PaymentSettings_navigation_34vB7"};